
<div>
  <align class="header" flex>
    <align>
      <h3 class="secondary-font">
        {{ indexId && index ? index.label : 'Index Snapshot' }}
      </h3>

      <pill-dropdown
        v-if="!indexId"
        v-model="activeIndexId"
        :options="indexOptions"
      />
    </align>

    <icon-link @click.native="viewIndex">
      View More
    </icon-link>
  </align>

  <div v-if="index" class="grid">
    <stat-item
      size="xlarge"
      success
      label="Index Value"
      :value="$filters.number(index.dailyIndex)"
    />

    <stat-item
      size="xlarge"
      :success="index.dailyPercentChange > 0"
      :error="index.dailyPercentChange < 0"
      label="Daily Change"
      :value="`${index.dailyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.dailyPercentChange)}`"
    />

    <stat-item
      size="xlarge"
      :success="index.monthlyPercentChange > 0"
      :error="index.monthlyPercentChange < 0"
      label="Monthly Change"
      :value="`${index.monthlyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.monthlyPercentChange)}`"
    />

    <stat-item
      size="xlarge"
      :success="index.quarterlyPercentChange > 0"
      :error="index.quarterlyPercentChange < 0"
      label="Quarterly Change"
      :value="`${index.quarterlyPercentChange > 0 ? '+' : ''}${$filters.percentage(index.quarterlyPercentChange)}`"
    />
  </div>
</div>
